import { APIService } from '../api/APIService';

export class CountyService {
    path: string;
    apiService: APIService;

    constructor(apiService: APIService) {
        const countyURI = import.meta.env.VITE_DS_COUNTIES;
        if (!countyURI) {
            throw new Error('countyURI not set');
        }
        this.path = countyURI;
        this.apiService = apiService;
    }

    getCounties(): Promise<endpoints.County[]> {
        return this.apiService.getData(this.path);
    }
}